import { XAxis, XAxisProps } from 'recharts';

import { X_AXIS_HEIGHT } from '../consts.ts';

type GraphXAxisProps = Omit<XAxisProps, 'label' | 'height'> & {
  label?: string;
};

export const GraphXAxis = ({ label, ...rest }: GraphXAxisProps) => (
  <XAxis
    {...(label
      ? {
          label: {
            position: 'insideBottom',
            value: label,
          },
          height: X_AXIS_HEIGHT,
        }
      : {})}
    {...rest}
  />
);
